import { render, staticRenderFns } from "./MediaDefaultThumbnail.vue?vue&type=template&id=9325c9a8&"
import script from "./MediaDefaultThumbnail.vue?vue&type=script&lang=js&"
export * from "./MediaDefaultThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports